import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography, Button } from '@mui/material';
import { projectActions } from '../../store/project';

const ProjectEmptyState = () => {
  const dispatch = useDispatch();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        height: '60vh',
        textAlign: 'center',
        px: 2,
      }}
    >
      <Typography variant="h6" color="text.secondary">
        Select a project to get started
      </Typography>
      <Button
        variant="contained"
        onClick={() => dispatch(projectActions.openProjectDrawer())}
      >
        Select Project
      </Button>
    </Box>
  );
};

export default ProjectEmptyState;
